// eslint-disable-next-line import/no-extraneous-dependencies
import {tableAnatomy} from '@chakra-ui/anatomy'
import {createMultiStyleConfigHelpers} from '@chakra-ui/react'

const {definePartsStyle, defineMultiStyleConfig} =
  createMultiStyleConfigHelpers(tableAnatomy.keys)

const receipt = definePartsStyle(() => {
  return {
    td: {
      verticalAlign: 'top',
      padding: 0,
    },
    tr: {
      th: {
        verticalAlign: 'top',
        padding: 0,
        whiteSpace: 'nowrap',
        paddingRight: '1em',
        fontSize: 'inherit',
        color: 'inherit',
        fontWeight: 'inherit',
      },
    },
  }
})

const statement = definePartsStyle(() => {
  return {
    thead: {
      boxShadow: 'none',
      tr: {
        borderTop: '1px solid',
        borderBottom: '1px solid',
        borderBottomColor: 'mld.neutral.600',
      },
    },
    tbody: {
      tr: {
        borderBottom: '1px solid',
        borderBottomColor: 'mld.neutral.600',
      },
      td: {
        paddingTop: '1.5em',
        paddingBottom: '1.5em',
        paddingLeft: '0.5em',
        paddingRight: '0.5em',
      },
    },
  }
})

const baseStyle = {
  thead: {
    bg: 'white',
    position: 'sticky',
    zIndex: 'sticky',
    insetBlockStart: 0,
    background: 'none',
    th: {
      padding: 0,
      textAlign: 'start',
      borderColor: 'mld.neutral.800',
      borderTop: '1px solid',
      borderBottom: '1px solid',
      _dark: {
        borderColor: 'mld.neutral.100',
      },
    },
  },
}

const sizes = {
  md: {
    th: {
      px: '6',
      py: '4',
      fontSize: 'sm',
      lineHeight: '3',
    },
    td: {
      px: '6',
      py: '2',
      fontSize: '16px',
    },
  },
  lg: {
    th: {
      fontSize: 'sm',
      lineHeight: '3',
    },
    td: {
      py: '7',
      fontSize: '16px',
    },
  },
}

export default defineMultiStyleConfig({
  sizes,
  baseStyle,
  variants: {receipt, statement},
})
